import { useJsApiLoader } from "@react-google-maps/api";
import { googleMapsLoaderOptions } from "../config/googleMaps";

const useGoogleMapsLoader = () => useJsApiLoader(googleMapsLoaderOptions);

export default useGoogleMapsLoader;
